"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../../components/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var FileUpload = function FileUpload(_ref) {
  var onDrag = _ref.onDrag,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onDragOver = _ref.onDragOver,
      onDragEnter = _ref.onDragEnter,
      onDragLeave = _ref.onDragLeave,
      onDrop = _ref.onDrop,
      onChange = _ref.onChange,
      ChooseLabel = _ref.ChooseLabel,
      DragLabel = _ref.DragLabel,
      _ref$accept = _ref.accept,
      accept = _ref$accept === void 0 ? 'image/*' : _ref$accept,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["onDrag", "onDragStart", "onDragEnd", "onDragOver", "onDragEnter", "onDragLeave", "onDrop", "onChange", "ChooseLabel", "DragLabel", "accept", "className"]);
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dragging = _useState2[0],
      setDragging = _useState2[1];

  var ref = (0, _react.useRef)(null);

  var handleDragOver = function handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    onDragOver && onDragOver(event);
  };

  var handleDragEnter = function handleDragEnter(event) {
    event.preventDefault();
    event.stopPropagation();
    setDragging(true);
    onDragEnter && onDragEnter(event);
  };

  var handleDragLeave = function handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
    onDragLeave && onDragLeave(event);
  };

  var handleDragEnd = function handleDragEnd(event) {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
    onDragEnd && onDragEnd(event);
  };

  var handleDrop = function handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
    onDrop && onDrop(event);
  };

  var handleDrag = function handleDrag(event) {
    event.preventDefault();
    event.stopPropagation();
    onDrag && onDrag(event);
  };

  var handleDragStart = function handleDragStart(event) {
    event.preventDefault();
    event.stopPropagation();
    setDragging(true);
    onDragStart && onDragStart(event);
  };

  var handleChange = function handleChange(event) {
    onChange && onChange(event);
  };

  var InputRef = (0, _react.useRef)(null);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      var _InputRef$current;

      InputRef === null || InputRef === void 0 ? void 0 : (_InputRef$current = InputRef.current) === null || _InputRef$current === void 0 ? void 0 : _InputRef$current.click();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, classes.FileUpload, dragging && classes.Dragging),
    encType: "multipart/form-data",
    onDrag: handleDrag,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    onDragOver: handleDragOver,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    ref: ref,
    onKeyDown: handleKeyDown,
    tabIndex: 0,
    "data-test-id": "file-upload"
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.InputWrapper
  }, /*#__PURE__*/_react["default"].createElement("input", {
    ref: InputRef,
    className: classes.Input,
    type: "file",
    id: "file",
    onChange: handleChange,
    accept: accept
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.Label,
    htmlFor: "file"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    glyph: 'upload-to-cloud',
    className: classes.Icon
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Text
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.ChooseLabel
  }, ChooseLabel), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.DragDropLabel
  }, " ", DragLabel)))));
};

exports["default"] = FileUpload;
//# sourceMappingURL=index.js.map